import { RadioGroup } from '@zep-us/zus';
import { type QuotePlanType } from '../constants/quizQuote.const';
import { type TrialEndQuoteDiscount } from '../utils/quoteCalculator';
import { formatDiscountRate, formatWon } from '../utils/quoteFormat';
import { type QuotePricingPolicy } from '../utils/quotePricingPolicy';
import { PlanTypeOption } from './PlanTypeOption';
import { QuoteSection } from './QuoteSection';

/** 체험 종료 할인 적용 시 개인 옵션 안내 (Figma 29111:1758). */
function getIndividualCopy(policy: QuotePricingPolicy | null, trialEndDiscount: TrialEndQuoteDiscount | null, isDiscountApplicable: boolean) {
  if (!policy) return {};
  if (!trialEndDiscount) {
    return {
      description: `인당 월 ${formatWon(policy.proUnitAmount)}원`
    };
  }
  const unitAmount = isDiscountApplicable ? Math.floor(policy.proUnitAmount * (1 - trialEndDiscount.discountRate)) : policy.proUnitAmount;
  return {
    badge: isDiscountApplicable ? `${formatDiscountRate(trialEndDiscount.discountRate)} 할인` : undefined,
    description: `인당 월 ${formatWon(unitAmount)}원${isDiscountApplicable ? ` (${trialEndDiscount.maxUserCount}명, 첫 ${trialEndDiscount.maxMonthCount}개월 할인)` : ''}`
  };
}

/**
 * 요금제 유형 — Pro 플랜에서 개인/학교·단체 선택 (Figma 13614-55984).
 *
 * Basic 은 선택지가 "개인" 하나뿐이라 BasicPlanTypeSection 으로 분리돼 있다.
 */
export function PlanTypeSection({
  value,
  onChange,
  policy,
  trialEndDiscount = null,
  isDiscountApplicable = true
}: {
  value: QuotePlanType;
  onChange: (value: QuotePlanType) => void;
  policy: QuotePricingPolicy | null;
  trialEndDiscount?: TrialEndQuoteDiscount | null;
  isDiscountApplicable?: boolean;
}) {
  const individual = getIndividualCopy(policy, trialEndDiscount, isDiscountApplicable);
  return <QuoteSection title="요금제 유형" data-sentry-element="QuoteSection" data-sentry-component="PlanTypeSection" data-sentry-source-file="PlanTypeSection.tsx">
      <RadioGroup value={value} onValueChange={onChange} className="gap-lg" data-sentry-element="RadioGroup" data-sentry-source-file="PlanTypeSection.tsx">
        <PlanTypeOption value="individual" title="개인" badge={individual.badge} description={individual.description} data-sentry-element="PlanTypeOption" data-sentry-source-file="PlanTypeSection.tsx" />
        <PlanTypeOption value="group" title="학교·단체" badge={policy ? `${formatDiscountRate(policy.groupDiscountRate)} 할인` : undefined} description={policy ? `인당 월 ${formatWon(policy.groupUnitAmount)}원 (최소 ${policy.groupMinUserCount}명, ${policy.groupMinMonthCount}개월 이상)` : undefined} data-sentry-element="PlanTypeOption" data-sentry-source-file="PlanTypeSection.tsx" />
      </RadioGroup>
    </QuoteSection>;
}